export type ClientInputs = {
	civilStatus: CivilStatus | null
	childrenInHousehold: number | null
	childrenAges: ChildrenAgeGroup[] | null
}

export enum ClientInputsType {
	None = 'none',
	CarLoan = 'carLoan',
	CarLeasing = 'carLeasing',
	ConsumerLoan = 'consumerLoan',
	HomeLoan = 'homeLoan',
}

export interface BudgetHelperQuestionnaireInputs extends ClientInputs {
	mergedFinances: string | null
	spouseConsent: string | null
}

export enum CivilStatus {
	None = 'none',
	Married = 'married',
	Alone = 'alone',
}

export enum ChildrenAgeGroup {
	Unknown = 'unknown',
	AgeGroup0To1 = 'ageGroup0To1',
	AgeGroup2To6 = 'ageGroup2To6',
	AgeGroup7To17 = 'ageGroup7To17',
	AgeGroupOver18 = 'ageGroupOver18',
}
